import React from 'react';
import { Section, preloader } from 'spectacle-ppa';
import { i18nData } from 'helpers/i18n';

import headingSlide from '../../baseSlides/headingSlide';
import balloonSlide from '../../baseSlides/balloonSlide';
import videoSlide from '../../baseSlides/videoSlide';

import imagePPALogo from '../../images/logo_ppa.png';
import esPowerStance from '../../images/characters/esPowerStance.png';
import esHandsOutWehey from '../../images/characters/esmeralda_hands_out_wehey.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel1_en from './level1_operationTapsOff.md';
import markdownFileLevel1_fr_CA from './level1_operationTapsOff.fr_CA.md';
import markdownFileLevel2_en from './level2_operationSaveWater.md';
import markdownFileLevel2_fr_CA from './level2_operationSaveWater.fr_CA.md';
import markdownFileLevel3_en from './level3_operationProtectWater.md';
import markdownFileLevel3_fr_CA from './level3_operationProtectWater.fr_CA.md';

const markdownFileLevel1 = i18nData({
  en: new MarkdownScript(markdownFileLevel1_en),
  fr_CA: new MarkdownScript(markdownFileLevel1_fr_CA)
});
const markdownFileLevel2 = i18nData({
  en: new MarkdownScript(markdownFileLevel2_en),
  fr_CA: new MarkdownScript(markdownFileLevel2_fr_CA)
});
const markdownFileLevel3 = i18nData({
  en: new MarkdownScript(markdownFileLevel3_en),
  fr_CA: new MarkdownScript(markdownFileLevel3_fr_CA)
});

const levels = {
  '1': { md: markdownFileLevel1 },
  '2': { md: markdownFileLevel2 },
  '3': { md: markdownFileLevel3 }
}

export function preloadMissionAssignment () {
  preloader([
    imagePPALogo,
    esPowerStance,
    esHandsOutWehey
  ]);
}

function missionAssignmentSection ({ level, regionData, i18n }) {
  const md = i18n(levels[level].md);
  const missionTitle = md.getSectionMetadata('Mission Assignment', 'Title', regionData);

  return (
    <Section id="mission-assignment">

      {/* Mission assignment*/}
      { (level === 2) &&
        videoSlide({
          id: 'intro-video',
          notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
          youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
        })
      }

      {/* Sizzle level 1 */}
      { (level === 1) &&
        headingSlide({
          id: 'sizzle',
          beforeImage: imagePPALogo,
          subHeading: i18n`Mission ${level}:<br/> ${missionTitle}`,
          notes: md.getSubSectionAsHtml('Mission Assignment', 'Notes', false, regionData),
          bgColor: 'black'
        })
      }

      {/* Sizzle other levels */}
      { (level !== 1) &&
        headingSlide({
          id: 'sizzle',
          beforeImage: imagePPALogo,
          subHeading: i18n`Mission ${level}:<br/> ${missionTitle}`,
          notes: md.getSubSectionAsHtml('Mission Assignment', 'Notes', false, regionData),
          bgColor: 'black'
        })
      }

      {/* Mission Instructions & Points */}
      {balloonSlide({
        id: 'instructions',
        characterSide: 'right',
        characterImage: esHandsOutWehey,
        notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
      })}

      {/* Mission Files Instructions */}
      {balloonSlide({
        id: 'mission-files',
        characterSide: 'right',
        characterImage: esPowerStance,
        notes: md.getSubSectionAsHtml('Mission Files', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Mission Files', 'Content', false, regionData)
      })}

    </Section>
  );
}

export default missionAssignmentSection;



// WEBPACK FOOTER //
// ./programs/h2whoa/sections/70_missionAssignment/missionAssignmentSection.jsx